import { GoogleMap } from '@react-google-maps/api';

import * as St from './RetailStoresMap.styles';
import { useRetailStoresMap } from './hooks/useRetailStoresMap';

const RetailStoresMap = () => {
  const {
    setMap,
    isGoogleMapsLoaded,
    onMapLoad,
    googleMapsOptions,
    googleMapsError,
  } = useRetailStoresMap();

  if (!isGoogleMapsLoaded || googleMapsError) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerStyle={St.googleMapStyle}
      options={googleMapsOptions}
      onLoad={onMapLoad}
      onUnmount={() => setMap(null)}
    />
  );
};

export default RetailStoresMap;
